export const boxHistory = function(){
    tableHandle();
}

function tableHandle(){
    let boxes = document.querySelectorAll('.box-history-table')
    boxes.forEach(function(box:HTMLElement){
        let timeoutScroll:any;
        box.addEventListener('scroll', function(e){
            clearTimeout(timeoutScroll);
            timeoutScroll = setTimeout(function(){
                let theadTable = <HTMLElement> box.querySelector('table thead');
                if (!theadTable){
                    return;
                }
    
                let val = box.scrollTop;
                if (val > 40){
                    theadTable.classList.add('scrolling');
                }
                else{
                    theadTable.classList.remove('scrolling');
                }
            }, 300)
        })
    })
}